import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ManageRoleType } from '@/types/menu';

export type ManageRoleState = {
  dataManageRole: ManageRoleType[];
};

export const manageRoleInitialState: ManageRoleState = {
  dataManageRole: [],
};

const slice = createSlice({
  name: 'manageRole',
  initialState: manageRoleInitialState,
  reducers: {
    setManageRolesAction(state, { payload }: PayloadAction<ManageRoleType[]>) {
      state.dataManageRole = payload;
    },
  },
});

export const { setManageRolesAction } = slice.actions;
export default slice.reducer;
